import type { Filters } from "./useBenefits.js"

export interface PickupPreset {
  id: string
  label: string
  getFilters: () => Partial<Filters>
  clearFilters: Partial<Filters>
  isActive: (filters: Filters) => boolean
}

export const PICKUP_PRESETS: PickupPreset[] = [
  {
    id: "thisMonth",
    label: "今月確定月",
    getFilters: () => ({ months: [new Date().getMonth() + 1] }),
    clearFilters: { months: [] },
    isActive: (filters) => {
      const currentMonth = new Date().getMonth() + 1
      return filters.months.length === 1 && filters.months[0] === currentMonth
    },
  },
  {
    id: "largeCapHighDividend",
    label: "大型株の高配当",
    getFilters: () => ({ capTiers: ["large"], minDividendYield: 4 }),
    clearFilters: { capTiers: [], minDividendYield: null },
    isActive: (filters) =>
      filters.capTiers.length === 1 &&
      filters.capTiers[0] === "large" &&
      filters.minDividendYield === 4,
  },
  {
    id: "cheapSmallCap",
    label: "お手軽小型株",
    getFilters: () => ({ capTiers: ["small"], maxAcquisitionAmount: 50000 }),
    clearFilters: { capTiers: [], maxAcquisitionAmount: null },
    isActive: (filters) =>
      filters.capTiers.length === 1 &&
      filters.capTiers[0] === "small" &&
      filters.maxAcquisitionAmount === 50000,
  },
]
